import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { InfoTooltip } from '@bluebeam/react-skyline-info-tooltip';
import { Label } from '@bluebeam/react-skyline-label';
import { useId } from '@react-aria/utils';
/** ReadOnlyField is a type of **molecule** to  display form data that cannot be altered by the user.  */
const ReadOnlyField = ({ className, children, emptyContent, label, tooltip, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    const contentId = useId();
    return (_jsxs("div", { className: className, ...dataAttributes, children: [_jsxs(Label, { htmlFor: contentId, className: "mb-1", children: [label, tooltip && _jsx(InfoTooltip, { tooltip: tooltip })] }), _jsx("div", { id: contentId, tabIndex: 0, className: buildClassName('skyline-text-body-1 text-black', className), children: children ? children : emptyContent })] }));
};
export default ReadOnlyField;
//# sourceMappingURL=ReadOnlyField.js.map